export function isReactNative(): boolean {
  return false;
}
